<script setup lang="ts">
import BotFooter from '@/components/BotFooter.vue'
import Cta from '@/components/Cta.vue'
import TopNav from '@/components/TopNav.vue'
import { howItWorks } from '@/data/howItWorks'
import { useLangTools } from '@/lang'
import { useRouter } from 'vue-router'

const { $tdb } = useLangTools(useRouter())
</script>

<template>
	<div>
		<div class="act_oval" />
		<TopNav />
		<div class="page-wrap">
			<div class="act_center act_w970">
				<h1 class="act_txt60 playfair balance act_no-marg act_pb-1">
					{{ $tdb(howItWorks[0], 'title') }}
				</h1>
				<p class="act_blue act_pb-2">
					{{ $tdb(howItWorks[0], 'subtitle') }}
				</p>
				<div class="how-list act_pb-3">
					<div v-for="item in howItWorks[0].points" :id="item.titleEN.replace(/\s/g, '')" :key="item._id" class="how-item white-box act_gap-2 act_flex align-center">
						<img width="524.5" height="350" class="act_round how-img" :src="item.image.imageURL" :alt="$tdb(item, 'title')">
						<div>
							<h3 class="playfair act_txt30  act_no-marg act_pb-1">
								{{ $tdb(item, 'title') }}
							</h3>
							<div class="how-item-txt" v-html="$tdb(item, 'body')" />
						</div>
					</div>
				</div>
				<Cta />
			</div>
		</div>
		<BotFooter />
	</div>
</template>
